/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCluster = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 16a3 3 0 1 1-.001 6.001A3 3 0 0 1 12 16zm0 2a1 1 0 1 0 .001 2.001A1 1 0 0 0 12 18zm0-16a3 3 0 0 1 1 5.829V9.17a3.002 3.002 0 0 1 1.873 3.694l2.393 1.687a3 3 0 1 1-1.154 1.634l-2.42-1.708c-.482.33-1.065.522-1.692.522s-1.21-.193-1.691-.522l-2.42 1.708a3 3 0 1 1-1.154-1.634l2.392-1.687A3.002 3.002 0 0 1 11 9.17V7.829A3 3 0 0 1 12 2zM5 16a1 1 0 1 0 .001 2.001A1 1 0 0 0 5 16zm14 0a1 1 0 1 0 .001 2.001A1 1 0 0 0 19 16zm-7-5a1 1 0 1 0 .001 2.001A1 1 0 0 0 12 11zM5 5a3 3 0 1 1-.001 6.001A3 3 0 0 1 5 5zm14 0a3 3 0 1 1-.001 6.001A3 3 0 0 1 19 5zM5 7a1 1 0 1 0 .001 2.001A1 1 0 0 0 5 7zm14 0a1 1 0 1 0 .001 2.001A1 1 0 0 0 19 7zm-7-3a1 1 0 1 0 .001 2.001A1 1 0 0 0 12 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCluster as Cluster };
